import React from "react";

/**
 * CalsideMark — the Calside brand mark rendered as an inline SVG.
 * Three terracotta stones stacked on a dark-green rounded-square chip.
 * Sizes automatically via the `size` prop (px). Defaults to 36 to match the
 * previous 9×9 tailwind chip that lived in the header/Verify page.
 */
export default function CalsideMark({ size = 36, className = "" }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      width={size}
      height={size}
      className={className}
      role="img"
      aria-label="Calside"
    >
      <rect x="0" y="0" width="64" height="64" rx="16" fill="#1A2E25" />
      {/* Bottom stone — largest */}
      <ellipse cx="32" cy="46" rx="20" ry="6" fill="#C46B54" />
      <ellipse cx="32" cy="45" rx="14" ry="2" fill="#DF947A" />
      {/* Middle stone */}
      <ellipse cx="32" cy="33" rx="14" ry="5" fill="#C46B54" />
      <ellipse cx="32" cy="32.2" rx="10" ry="1.6" fill="#DF947A" />
      {/* Top stone — smallest */}
      <ellipse cx="32" cy="22" rx="9" ry="4" fill="#C46B54" />
      <ellipse cx="32" cy="21.4" rx="6.4" ry="1.4" fill="#DF947A" />
    </svg>
  );
}
